import { useEffect, useRef } from "react";
import { usePostHog } from "posthog-js/react";
import { useStaffMeQuery } from "@/shared/api";

/**
 * Custom hook to identify the current user in PostHog for session tracking and analytics.
 * Automatically identifies users when authenticated.
 */
export function usePostHogIdentify() {
  const posthog = usePostHog();
  const { data: { result: user } = {} } = useStaffMeQuery();
  const identifiedUserIdRef = useRef<string | null>(null);

  // Identify user in PostHog when user data becomes available
  useEffect(() => {
    if (user && posthog && identifiedUserIdRef.current !== user.id) {
      try {
        posthog.identify(user.id, {
          first_name: user.first_name,
          last_name: user.last_name,
        });

        identifiedUserIdRef.current = user.id;
      } catch (error) {
        console.error("Failed to identify user in PostHog:", error);
      }
    }
  }, [user, posthog]);
}
